module.exports = __webpack_public_path__ + "static/media/house8lg.c0b63105.png";